import React, { useEffect, useState } from "react";

function Input(props) {
  const { img, label,stepid, name, handleChange,id,journey, value, submit, required,validation } = props;
  const [error, setError] = useState(false);
  // console.log("prop.value",value);
  // console.log(id);
  // console.log(stepid);

  
 
  const onChange = (event) => {
    const { name, value } = event.target
  
    // console.log(value);
    // console.log(stepid);
    if(journey?.steps.length!==0){

    }
    



    handleChange(stepid,event);
  }


  useEffect(() => {
    if (submit) {
     
     if (validation === "required"){
        setError(typeof value === 'string' && value.trim().length === 0);
        //  console.log( typeof value === 'string' && value.trim().length === 0);
        //  console.log(value);

      }
    }
  }, [submit])
  return (
    <>
    <div>
      <span className="det-label">
        {img!=="" ?
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
            alt="i"
          /> : ''}
        {label}
      </span>
      {name === "description" || name === "stepdescription" ?
        <textarea rows={20}  cols={10} placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }}  className="textarea-custom" value={value} name={name} onChange={onChange} />
        :
        <input type="text" placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }} className="text-custom" value={value} name={name} onChange={onChange} />

      }
      </div>
      {error&& validation==="password" &&
      <>
      <p style={{textAlign:"end",marginBottom:"0",fontSize:"12px",color:"red"}}>minimum 8 characters Required</p>
      </>
      }
    </>
  );
}

export default React.memo(Input);
